import React from 'react'
import Contacts from '../components/Contacts';

function Contact() {
  return (
    <div className="mt-5">
      <Contacts/>
      </div>
  )
}

export default Contact;